<div class="pincode-input">
  <input type="tel" aria-label="6 Digit Verification Code"
         (input)="onChange($event)"
         autocomplete="one-time-code" pattern="[0-9]{6}"
         inputmode="numeric"
         (focus)="onFocus($event)">
</div>
